import { FC, memo } from 'react'

import { CircularProgressProps } from './CircularProgress.types'
import { getFile } from './assets'

import { s } from './styles'

export const CircularProgress: FC<CircularProgressProps> = memo((props) => {
  const {
    durationInSeconds = 1.5,
    backdrop,
    centered,
    color = 'brand',
    size = 64,
    'data-qa': dataQA,
    value,
    className,
    style
  } = props
  const safeValue = value !== undefined ? Math.round(Math.min(Math.max(value, 0), 99)) : undefined
  const svg = getFile(color, size)

  const component = (
    <s.box $centered={centered} $sizePX={size} data-qa={dataQA} className={className} style={style}>
      {typeof safeValue !== 'undefined' && size !== 16 && <s.label $color={color}>{safeValue}</s.label>}
      <s.body
        $brand={color === 'brand'}
        $sizePX={size}
        $duration={durationInSeconds}
        dangerouslySetInnerHTML={{ __html: svg }}
      />
    </s.box>
  )

  if (centered && backdrop) {
    return <s.backdrop style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>{component}</s.backdrop>
  }

  return component
})
